/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Delete_Confirm_DeclineInputs */

const en_company_jobs_delete_confirm_decline = /** @type {(inputs: Company_Jobs_Delete_Confirm_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_company_jobs_delete_confirm_decline = /** @type {(inputs: Company_Jobs_Delete_Confirm_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Company_Jobs_Delete_Confirm_DeclineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_delete_confirm_decline = /** @type {((inputs?: Company_Jobs_Delete_Confirm_DeclineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Delete_Confirm_DeclineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_delete_confirm_decline(inputs)
	return en_company_jobs_delete_confirm_decline(inputs)
});